<template>
  <div class="modal">
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <table>
          <tr>
            <td class="pa-2"> ID </td>
            <td class="pl-2"> {{ dealer.id }} </td>
          </tr>
          <tr>
            <td class="pa-2"> ชื่อ - นามสกุล </td>
            <td class="pl-2"> {{ dealer.firstName }} {{ dealer.lastName }} </td>
          </tr>
          <tr>
            <td class="pa-2"> ชื่อเล่น </td>
            <td class="pa-2"> {{ dealer.nickName }} </td>
          </tr>
          <tr>
            <td class="pa-2"> อายุ </td>
            <td class="pa-2"> {{ dealer.dob | displayAge() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> Email </td>
            <td class="pa-2"> {{ dealer.email | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> เพศ </td>
            <td class="pa-2"> {{ dealer.gender | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> รหัสตัวแทนเดิม </td>
            <td class="pa-2"> {{ dealer.oldDealerId | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> รหัสตัวแทนแม่ทีม </td>
            <td class="pa-2"> {{ dealer.teamParentId | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> สายทีม </td>
            <td class="pa-2"> {{ dealer.classTeam | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> สถานะ </td>
            <td class="pa-2"> {{ dealer.sellerStatus | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> ที่อยู่ที่สามารถติดต่อได้สะดวก </td>
            <td class="pa-2"> {{ dealer.address | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> จังหวัด </td>
            <td class="pa-2"> {{ dealer.province | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> รหัสไปรษณีย์ </td>
            <td class="pa-2"> {{ dealer.postCode | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> เบอร์โทรศัพท์ที่ติดต่อได้สะดวก </td>
            <td class="pa-2"> {{ dealer.tel | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> LINE ID </td>
            <td class="pa-2"> {{ dealer.lineId | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> Instagram </td>
            <td class="pa-2"> {{ dealer.instagram | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> Facebook </td>
            <td class="pa-2"> {{ dealer.facebook | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> Facebook Fanpage </td>
            <td class="pa-2"> {{ dealer.facebookPage | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> พื้นที่ขาย </td>
            <td class="pa-2"> {{ dealer.sellArea | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> วันที่ยอมรับข้อตกลง </td>
            <td class="pa-2"> {{ dealer.acceptedDate | localDate() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> วันที่สมัคร </td>
            <td class="pa-2"> {{ dealer.createdAt | localDate() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> วันที่ Update ล่าสุด </td>
            <td class="pa-2"> {{ dealer.updatedAt | localDate() }} </td>
          </tr>
        </table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" offset="2">
        <img
          :src="dealer.nationalCardImageUrl"
          width="300"
          style="margin: auto;"
          @error="imgCheck('nationalCart')"
          v-if="hasNationalCartImg">
        <div v-else>
          <a :href="hasNationalCartImg" target="_blank">The image</a> could not be loaded.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" offset="2">
        <img
          :src="dealer.sellerCardImageUrl"
          width="300"
          style="margin: auto;"
          @error="imgCheck('seller')"
          v-if="hasSellerImg">
        <div v-else>
          <a :href="hasSellerImg" target="_blank">The image</a> could not be loaded.
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  props: ['dealer'],
  data () {
    return {
      hasSellerImg: true,
      hasNationalCartImg: true
    }
  },
  methods: {
    imgCheck (type) {
      if (type === 'seller') {
        this.hasSellerImg = false
      } else {
        this.hasNationalCartImg = false
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .modal {
    background-color: #fff;
    z-index: 3;
  }
</style>